import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Microbiologia/editMicrobiologia`, method: 'POST', body: values, token: token})
}
